import { css } from "@emotion/react";

export const signInText = css`
  white-space: nowrap;
`;
